import type { ReactNode } from "react";
import {
  IconInfoCircle,
  IconShieldLock,
  IconUserShield,
  IconUserCog,
  IconHeadset,
  IconMessageCircle,
} from "@tabler/icons-react";
import type { NotificationType } from "../types";

/** Ícone por tipo de notificação do backoffice (rendering type-driven, ADR-0028). */
export function notificationIcon(type: NotificationType, size = 16): ReactNode {
  switch (type) {
    case "AdminRoleChanged":
      return <IconUserCog size={size} />;
    case "AdminTwoFactorReset":
      return <IconShieldLock size={size} />;
    case "AdminAccountStatusChanged":
      return <IconUserShield size={size} />;
    case "SupportTicketOpened":
      return <IconHeadset size={size} />;
    case "SupportTicketMessageAdded":
      return <IconMessageCircle size={size} />;
    default:
      return <IconInfoCircle size={size} />;
  }
}

/** Cor de fundo/realce do ícone por tipo (segue o design system shadcn/Tailwind). */
export const notificationIconTint: Record<NotificationType, string> = {
  AdminRoleChanged: "bg-brand-50 text-brand-600",
  AdminTwoFactorReset: "bg-warning-soft text-warning",
  AdminAccountStatusChanged: "bg-info-soft text-info",
  SupportTicketOpened: "bg-info-soft text-info",
  SupportTicketMessageAdded: "bg-brand-50 text-brand-600",
};
